<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <div><h2 class="page-title">Approval Bongkar</h2></div>
        <div class="d-flex flex-row justify-content-end">
          <template v-if="user.type !== 'ADMIN_EKSPEDISI'">
            <div class="mr-3">
              <Multiselect
                v-model="filter.selectedStatus"
                :options="statusOptions"
                :custom-label="(option) => option.label"
                track-by="value"
                label="label"
                placeholder="Status"
                multiple
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="regions"
                v-model="filter.region"
                :deselect-label="''"
                placeholder="All Regions"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="ekspedisi.map((x) => x.id)"
                :custom-label="(opt) => ekspedisi.find((x) => x.id == opt).kode"
                placeholder="All Ekspedisi"
                v-model="filter.ekspedisi"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <div class="input-group">
                <flat-pickr
                  :config="rangePickr"
                  placeholder="Select Date"
                  v-model="selected.date"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mr-3">
              <Multiselect
                v-model="filter.selectedStatus"
                :options="statusOptions"
                :custom-label="(option) => option.label"
                track-by="value"
                label="label"
                placeholder="Status"
                multiple
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="gudang.map((x) => x.loc_code)"
                :custom-label="
                  (opt) => gudang.find((x) => x.loc_code == opt).loc_code
                "
                placeholder="Gudang"
                v-model="filter.gudang"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <div class="input-group">
                <flat-pickr
                  :config="rangePickr"
                  placeholder="Select Date"
                  v-model="selected.date"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
            <div class="mr-3">
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                "
                @click="modal.upload = true"
              >
                Upload File
              </button>
            </div>
            <div class="mr-3">
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                "
                @click="redirectCreateBongkarPage()"
              >
                Create Bongkar
              </button>
            </div>
          </template>
          <a
            href=""
            class="btn"
            style="margin-right: -1rem !important; padding: 0"
          >
            <img
              src="@/assets/img/notification.svg"
              alt=""
              style="display: none"
            />
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Table Start -->
    <div class="innerBox mt-4">
          <div class="row">
            <div class="col-2">
            <label style="font-size: 20px; color: #4d4d4d; font-weight: 600">
              Approval Bongkar List
            </label>
          </div>
          <div class="col">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white">
                  <i class="fas fa-search"></i>
                </span>
              </div>
              <input
                class="form-control filterInput col-lg-2"
                type="search"
                placeholder="Search by Nopol"
                aria-label="Search"
                v-model="filter.nopol"
                @input="vue_universal_table.update++"
                style="border-left: 0"
              />
            </div>
          </div>
          </div>
          <vue-universal-table
            api_url="/api/register-bongkar/list"
            :filter="filter"
            :indexing="true"
            :fields="vue_universal_table.fields"
            :update="vue_universal_table.update"
            :buttons="vue_universal_table.buttons"
            :process_data="vue_universal_table.process_data"
            :disable_limit_per_page="true"
            :table_striped="false"
            @onDelete="deleteApprovalBongkar"
            @onEdit="editApprovalBongkar"
            @onApproval="openApprovalModal"
          />
          <!-- <table class="table tms-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Nopol</th>
                <th>Ekspedisi</th>
                <th>Asal Plant</th>
                <th>Tanggal Muat</th>
                <th>Gudang Tujuan</th>
                <th>Tanggal Bongkar</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.nopol }}</td>
                <td>{{ item.ekspedisi }}</td>
                <td>{{ item.plant_name }}</td>
                <td>{{ item.tanggal_muat }}</td>
                <td>{{ item.gudang }}</td>
                <td>{{ item.approval_warehouse }}</td>
                <td>{{ item.status }}</td>
                <td>
                  <button
                    v-if="item.status === 'PENDING'"
                    class="btn btn-secondary"
                    style="
                      background-color: #82b0ef;
                      color: #ffffff;
                      border: none;
                    "
                    @click="openApprovalModal(item.id)"
                  >
                    Approval
                  </button>
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>
    <!-- Table End -->

    <!-- Modal for approving by ID -->
    <div v-if="showModal" class="modal" style="overflow: hidden">
      <div class="modal-content" style="height: 90vh">
        <div class="modal-header">
          <label style="font-size: 18px; font-weight: bold"
            >Konfirmasi Approval</label
          >
          <button type="button" class="close" @click="closeApprovalModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body text-center"
          style="color: #909090; height: auto"
        >
          Apakah Anda menyetujui tanggal bongkar {{ selected.date }}? jika
          tidak, silahkan isi tanggal bongkar atau gudang tujuan dibawah ini.
        </div>
        <div class="col" style="padding-bottom: 0; padding-top: 0">
          <label style="font-weight: bold">Tanggal Bongkar</label>
          <div class="form-group row ml-1" style="padding: 0">
            <input
              class="mr-3"
              type="checkbox"
              id="option1"
              name="options"
              value="range-picker"
              v-model="checked.rangePicker"
            />
            <div class="col-md-10">
              <div class="input-group p-0">
                <flat-pickr
                  :config="rangePickrModal"
                  placeholder="Select Date"
                  v-model="modal.date"
                  :disabled="selected.rangePicker"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="padding-bottom: 0; padding-top: 0">
          <label style="font-weight: bold">Gudang Tujuan</label>
          <div class="form-group row ml-1" style="padding: 0">
            <input
              class="mr-3"
              type="checkbox"
              id="option1"
              name="options"
              value="select"
              v-model="checked.select"
            />
            <div class="col-md-10">
              <Multiselect
                :options="gudang.map((x) => x.id)"
                :custom-label="
                  (opt) => gudang.find((x) => x.id == opt).loc_code
                "
                placeholder="Gudang"
                v-model="modal.gudang"
                class="tms-multiselect"
                :disabled="selected.select"
                style="padding: 0"
              />
            </div>
          </div>
        </div>
        <div class="form-group" style="padding-top: 0">
          <label style="font-weight: bold">Notes</label>
          <div class="col-md-10" style="padding-left: 0">
            <textarea rows="5" cols="45" class="mr-2"></textarea>
          </div>
          <!-- <input type="textarea" id="notesInput" name="notesInput" style="width: auto; height: 123px;"> -->
        </div>
        <div
          class="modal-footer"
          style="display: flex; justify-content: space-between"
        >
          <button
            class="btn btn-secondary"
            style="
              background-color: #ffb9b9;
              color: #ffffff;
              border: none;
              width: 180px;
            "
            @click="approveRequest('REJECTED')"
          >
            Reject
          </button>
          <button
            class="btn btn-secondary"
            style="
              background-color: #82b0ef;
              color: #ffffff;
              border: none;
              width: 180px;
            "
            @click="approveRequest('APPROVED')"
          >
            Approve
          </button>
        </div>
      </div>
    </div>

    <BongkarMuatUpload
      v-if="modal.upload"
      @closeModal="modal.upload = false"
      @onFinish="fetchData()"
    />
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import qs from "qs";
import moment from "moment";
import debounce from "debounce";
import Multiselect from "vue-multiselect";
import BongkarMuatUpload from "./BongkarMuatUpload.vue";

export default {
  metaInfo: {
    title: "Approval Bongkar",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    let user = this.$store.getters.currentUser;

    let buttons = null;
    let fields = null;

    if (user.type !== "ADMIN_EKSPEDISI") {
      buttons = [
        {
          title: "Approval",
          variable: null,
          class: "btn btn-secondary",
          style: "background-color: #82b0ef;color: #ffffff;border: none;",
          condition: `data.status == 'PENDING'`,
        },
      ];
      fields = [
          { title: "Nopol", variable: "nopol" },
          { title: "Ekspedisi", variable: "ekspedisi_kode" },
          { title: "Asal Plant", variable: "plant_name" },
          { title: "Tanggal Muat", variable: "tanggal_muat" },
          { title: "Gudang Tujuan", variable: "gudang" },
          {
            title: "Tanggal Bongkar",
            variable: "date",
          },
          { title: "Status", variable: "status" },
        ]
    } else {
      buttons = [
        {
          title: "Edit",
          variable: null,
          class: "fas fa-edit  btn-secondary rounded-button float-right",
        },
        {
          title: "Delete",
          variable: "id",
          class: "fas fa-trash  btn-secondary rounded-button",
        },
      ];
      fields = [
          { title: "Nopol", variable: "nopol" },
          { title: "Gudang Tujuan", variable: "gudang" },
          {
            title: "Tanggal Bongkar",
            variable: "date",
          },
          { title: "Status", variable: "status" },
        ]
    }

    return {
      data: [],
      showModal: false,
      selectedId: null,
      options: "",
      user,

      approvalStatus: "", // Added approvalStatus property
      selectedGudang: null,
      selectedDate: null,
      ekspedisi: this.$store.getters.getEkspedisi,
      gudang: this.$store.getters.getWarehouse.filter(val => val.loc_code !== 'All'),
      regions: this.$store.getters.getRegion,
      filter: {
        start: startDate,
        end: currentDate,
        search: null,
        gudang: null,
        selectedStatus: [],
        status: [],
        region: null,
        nopol: null,
      },
      vue_universal_table: {
        fields,
        buttons,
        update: 0,
        process_data: `
          for (var i in data) data[i].approval_warehouse = data[i].approval_warehouse ?? '-'
        `,
      },
      checked: {
        rangePicker: false,
        select: false,
      },
      modal: {
        date: `${startDate}`,
        gudang: null,
        upload: false,
      },
      statusOptions: [
        { value: 0, label: "PENDING" },
        { value: 1, label: "APPROVED" },
        { value: 2, label: "REJECTED" },
        { value: 3, label: "APPROVE UPDATE GUDANG" },
        { value: 4, label: "APPROVE UPDATE TANGGAL" },
        { value: 5, label: "APPROVE UPDATE SEMUA" },
      ],
      rangePickr: {
        mode: 'range',
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
      },
      rangePickrModal: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
        minDate: moment().format('YYYY-MM-DD')
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
        rangePicker: true,
        select: true,
      },
    };
  },
  components: {
    Multiselect,
    BongkarMuatUpload,
  },
  computed: {
    selectedStatusValues() {
      return this.filter.selectedStatus.map((label) => {
        const option = this.statusOptions.find(
          (option) => option.label === label
        );
        return option ? option.value : null;
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    filter: {
      deep: true,
      handler: "updateDebounceData",
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
    "checked.rangePicker"() {
      if (this.checked.rangePicker) {
        this.selected.rangePicker = false;
      } else {
        this.selected.rangePicker = true;
      }
    },
    "checked.select"() {
      if (this.checked.select) {
        this.selected.select = false;
      } else {
        this.selected.select = true;
      }
    },
  },
  methods: {
    updateDebounceData: debounce(function () {
      if (this.filter.gudang === "All" || this.filter.region === "All") {
        this.filter = { ...this.filter, gudang: null, region: null };
      }
      if (this.filter.selectedStatus.length > 0) {
        this.filter.status = this.filter.selectedStatus
          .map((x) => x.value)
          .join(",");
      }
      this.vue_universal_table.update++;
    }, 1500),
    editApprovalBongkar(editData) {
      const data = JSON.parse(editData);
      this.$router.push({
        name: "EditBongkar",
        params: { data, id: data.id },
      });
    },
    deleteApprovalBongkar(id) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/register-bongkar/delete/" + id)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `Approval Bongkar has been successfully deleted`,
                });
                // Fetch and update data after successful deletion
                this.vue_universal_table.update++;
              })
              .catch((err) => {
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: err.response.data.message,
                });
              });
          }
        });
    },
    // onClick(truck) {
    //     this.$store.state.truckData = truck;
    //     this.$router.push({path: '/dashboard/truck-list/detail'})
    // },
    fetchData() {
      // Convert selectedStatus objects to an array of labels
      const selectedStatusLabels = this.filter.selectedStatus.map(
        (option) => option.value
      );

      // Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      console.log(
        "%cHighlightLabelMaker.vue line:274 filterlessFilter",
        "color: #007acc;",
        filterlessFilter
      );
      delete filterlessFilter.filter;

      // Add the converted selectedStatusLabels to the filter object
      filterlessFilter.status = selectedStatusLabels;

      // Fetch data from the API
      axios
        .get(
          `/api/register-bongkar/list?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((response) => {
          this.data = response.data.data; // Update data with new data from the API
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    openApprovalModal(approvalData) {
      const parseApprovalData = JSON.parse(approvalData);
      this.selectedId = parseApprovalData.id;
      this.approvalStatus = parseApprovalData.status; // Set approval status
      this.showModal = true;
      this.selectedGudang = parseApprovalData.gudang_id;
      this.selectedDate = parseApprovalData.date;
    },
    closeApprovalModal() {
      this.showModal = false;
    },
    redirectCreateBongkarPage() {
      this.$router.push({ name: "CreateBongkar" });
    },
    approveRequest(status) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          const approvalData = {
            id: this.selectedId,
            status: status, // Use the selected status
          };

          if (this.checked.rangePicker) {
            approvalData.date = this.modal.date;
          } else {
            approvalData.date = this.selectedDate;
          }

          if (this.checked.select) {
            approvalData.gudang = this.modal.gudang;
          } else {
            approvalData.gudang = this.selectedGudang;
          }

          // Send approval/rejection request to the API
          axios
            .put("/api/register-bongkar/approve", approvalData)
            .then(() => {
              this.closeApprovalModal();
              this.vue_universal_table.update++;
              // Optionally, you can update the status in the table
              const itemToUpdate = this.data.find(
                (item) => item.id === this.selectedId
              );
              if (itemToUpdate) {
                itemToUpdate.status = status;
              }
            })
            .catch((error) => {
              console.error("Error approving/rejecting request:", error);
              this.closeApprovalModal();
            });
        }
      });
    },
    // confirmDelete(idToDelete) {
    //     // Use SweetAlert2 to display a confirmation dialog
    //     Swal.fire({
    //         title: 'Are you sure?',
    //         text: 'You won\'t be able to revert this!',
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, delete it!',
    //         cancelButtonText: 'No, cancel',
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //         // If the user confirms the delete, proceed with the DELETE request

    //         // Define the URL of the DELETE request
    //         const url = '/api/register-muat/delete/';

    //         // Define the request body
    //         const requestBody = {
    //             id: idToDelete
    //         };

    //         // Make the DELETE request
    //         axios
    //             .delete(url, { data: requestBody }) // Pass the request body in the "data" option
    //             .then(response => {
    //             // Handle the response, e.g., show a success message
    //             Swal.fire('Deleted!', 'The record has been deleted.', 'success');
    //             })
    //             .catch(error => {
    //             // Handle errors, e.g., show an error message
    //             Swal.fire('Error!', 'An error occurred while deleting the record.', 'error');
    //             });
    //         }
    //     });
    // },
    // editBongkar(id) {
    //     // Navigate to the EditBongkarPage.vue with the id of the record to edit
    //     this.$router.push({ name: 'EditBongkar', params: { id } });
    // },
  },
};
</script>

<style scoped>
.modal {
  /* Add your modal styles here */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal div {
  /* Add your modal content styles here */
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.modal-content {
  background: white;
  width: 500px;
  height: 600px;
  margin: 100px auto;
  padding: 20px;
  overflow-y: auto;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.prefix-icon {
  position: absolute;
  right: 15px;
  top: 20px;
  transform: translateY(-50%);
}

.prefix-input .elegant-flatpickr {
  padding-right: 35px;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.tms-button-circular {
  width: 40px; /* Set the width and height to the same value for a perfect circle */
  height: 40px;
  border-radius: 50%; /* Makes the button circular */
  background-color: #d8e4ff; /* Sets the background color */
  padding: 10px 20px; /* Adjust padding to fit your content */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
}

/* tms-table start */
.tms-table {
  width: 100%;
  border-collapse: collapse;
}

.tms-table th,
.tms-table td {
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
  color: #bcbcbc;
  font-weight: normal;
  border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
  font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
  border-top: none;
}
/* tms-table end */

.short-header {
  width: 15%;
}

.tms-multiselect .multiselect__input {
  border: none; /* Remove border */
  box-shadow: none; /* Remove box shadow if any */
}
</style>
